import {RightHandPanel} from "../components/RightHandPanel.tsx";
import {useMarketingWorkflow} from "../hooks/useMarketingWorkflow.ts";
import {useSearchParams} from "react-router-dom";


export const IndexPage = () => {

    const [searchParams,] = useSearchParams()

    const planId = searchParams.get('plan')

    const {
        context,
    } = useMarketingWorkflow();

    const modifiedContext = context;
    if (planId) {
        modifiedContext.planId = planId;
    }

    return (
        <RightHandPanel context={context}/>
    );

}
